import qs from '@halobear/utils/qs'
import { getIsMiniapp } from './miniapp'

export const isMyApp = qs.get('app') === 'halo'

export const isSupportTouch = ('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch

export const isMobile = /phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/i.test(navigator.userAgent)

export const isIphoneX = /iphone/gi.test(navigator.userAgent) && (screen.height == 812 && screen.width == 375)

export const replaceToken = str => str.replace(/(^|&)token=(.*?)(?=(&|$))/g, "").replace(/&$/, "")

export {
  getIsMiniapp
}